import { useQuery } from '@tanstack/react-query';
import { client, RxTableResponseRow } from '../../api';
import { formatName } from '../../utils';
import { RxFilterValues } from '../../types';
import { formatStandardDateLocaleString } from 'shared-utils/utils/formatDate';

import type { SortingState } from '@tanstack/react-table';
import { getRxSortParams } from './utils';

export const useFetchPrescriptions = (
  page: number,
  per_page: number,
  search: string,
  filterValues: RxFilterValues,
  sorting: SortingState,
  enabled: boolean = true,
) => {
  const prescriber_npi = filterValues.prescriber;
  const office_name = filterValues.office;
  const drug_name = filterValues.drug;
  const drug_category = filterValues.drug_category;
  const status = filterValues.status;
  const awaiting_office = filterValues.awaitingOffice;
  const awaiting_patient = filterValues.awaitingPatient;
  const overall_status = filterValues.overallStatus;
  const created_at_start = filterValues.startDate;
  const created_at_end = filterValues.endDate;

  const { sort_by, sort_desc } = getRxSortParams(sorting);
  return useQuery({
    queryKey: ['prescriptions', page, search, filterValues, sorting],
    queryFn: () =>
      client
        .get('/rxs', {
          params: {
            page: page + 1,
            per_page,
            search,
            prescriber_npi,
            office_name,
            drug_name,
            drug_category,
            status,
            awaiting_office,
            awaiting_patient,
            overall_status,
            created_at_start: created_at_start || undefined,
            created_at_end: created_at_end || undefined,
            sort_by,
            sort_desc,
          },
        })
        .then((res) => {
          const formattedData = res.data.results.map((item: RxTableResponseRow) => ({
            ...item,
            prescription_recieved_at: formatStandardDateLocaleString(item.prescription_recieved_at),
            prescriber_name: formatName(item.prescriber_name),
            patient_name: formatName(item.patient_name),
          }));
          return {
            results: formattedData,
            total: res.data.total,
          };
        }),
    enabled,
  });
};
